import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import axios from "axios";

// Components
import LoadingSpinner from './components/loading-spinner.vue';
import RawHtml from './components/raw-html.vue';

// Vue Router settings
const router = new VueRouter({
  mode: 'history',
});

// CancelTokens for canceling previous Axios requests.
const CancelToken = axios.CancelToken;
let source;

if (document.getElementById('related-blog-events') != null) {
  new Vue({
    router,
    data() {
      return {
        query: window.__SEARCH__.staff,
        isLoading: false,
        searchResults: [],
        currentPage: window.__SEARCH__.pageNum || 1,
        nextPage: (window.__SEARCH__.pageNum + 1) || null,
        totalPages: null,
        baseUrl: '/related-blog-events',
      }
    },
    methods: {
      loadMore: function() {
        if (source) {
          source.cancel();
        }
        source = axios.CancelToken.source();

        this.isLoading = true;

        axios.get(this.searchApi, {
          cancelToken: source.token
        })
        .then(response => {
          this.isLoading = false;

          // Using the spread operator here because Array.prototype.push.apply()
          // doesn't update the watcher on searchResults for some reason.
          [...this.searchResults] = [...this.searchResults, ...response.data.data]

          let pagination = response.data.meta.pagination;
          this.currentPage = pagination.current_page;
          this.totalPages = pagination.total_pages;
          if (this.currentPage < this.totalPages) {
            this.nextPage = this.currentPage + 1;
          } else {
            this.nextPage = 0;
          }
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            console.log(error.message);
          } else {
            this.isLoading = false;
            console.log(error.message);
          }
        })
        .finally(() => {
        });
      }
    },
    computed: {
      searchApi: function() {
        return `${this.baseUrl}.json/p${this.nextPage}?staff=${encodeURIComponent(this.query)}`;
      },
      showNextPage: function() {
        return (this.nextPage > 1 && this.isLoading == false);
      },
      nextPageUrl: function() {
        if (this.nextPage > 1) {
          return `${this.baseUrl}/p${this.nextPage}?staff=${encodeURIComponent(this.query)}`;
        } else {
          return null;
        }
      }
    },
    components: {
      LoadingSpinner,
      RawHtml
    }
  }).$mount('#related-blog-events')
}
